declare var pagination:any;

export const boxTable = function(){
    tableHandle();
    tablePages();
}

function tableHandle(){
    let trTable = document.querySelectorAll('table tbody tr');
    trTable.forEach(function(trItem, index){
        let allCb = trItem.querySelector('td[data-checked="all"');
        if (!allCb){
            return false;
        }
        let expCb = trItem.querySelectorAll('td[data-checked]:not([data-checked="all"])');
        let inp = <HTMLInputElement>allCb.querySelector('input[type="checkbox"');

        if (checkedAll(expCb) == true){
            inp.checked = true;
        }
        if (inp){
            inp.addEventListener('change', function(){
                if (inp.checked){
                    expCb.forEach(function(expItem){
                        let expInp = <HTMLInputElement>expItem.querySelector('input[type="checkbox"]');
                        if (expInp){
                            expInp.checked = true;
                        }
                    })
                }
                else{
                    expCb.forEach(function(expItem){
                        let expInp = <HTMLInputElement>expItem.querySelector('input[type="checkbox"]');
                        if (expInp){
                            expInp.checked = false;
                        }
                    })
                }
            })
        }

        expCb.forEach(function(expItem){
            let expInp = <HTMLInputElement>expItem.querySelector('input[type="checkbox"]');
            expInp.addEventListener('change', function(){
                if (checkedAll(expCb) == true){
                    inp.checked = true;
                }else{
                    inp.checked = false;
                }
            })
        })
    })
}

function checkedAll(cbList:any){
    let checked = true;
    cbList.forEach(function(item:HTMLElement){
        let inpCb = <HTMLInputElement> item.querySelector('input[type="checkbox"]');

        if (inpCb){
            if (inpCb.checked == false){
                checked = false;
                return false;
            }
        } 
    })
    
    return checked;
}

function tablePages(){
    let tables = document.querySelectorAll('.box-table');
    tables.forEach(function(table, idx){

        if (table.classList.contains('no-page')){
            return;
        }

        table.classList.add(`pagination-${idx}`)

        let ulPages = document.createElement('ul');
        ulPages.classList.add('box-pagination');

        table.append(ulPages);
        // let rows = table.querySelectorAll('tbody tr');

        new pagination({
            param: `tbl-${idx}`,
            selector: `.pagination-${idx} .box-pagination`,
            items: `.pagination-${idx} tbody tr`,
            page: 10
        });
    })
}